import { useState, useRef, useEffect } from 'react'

import './Sort.scss'
import { useTranslation } from 'react-i18next'

import icons from '../../assets/BuildIcons/Icons'
import SortByIcon from '../../assets/SortByIcon.svg'
import { getSortIndex } from '../../functions/getAlgoliaIndex'
import CustomStats from '../Stats/Stats'

import { Sort, OptionValue } from './Sort'

const { popular, asc, desc, newer } = getSortIndex()

const CustomSortBy = (currentRefinement: any) => {
  const win = window
  const localhost = win.location.hostname === 'localhost'
  const { t } = useTranslation()
  const [showSort, setShowSort] = useState(false)

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowSort(false)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)

  return (
    <div ref={wrapperRef}>
      <div className="customSort">
        <span>
          <button
            className="sortButton"
            style={{ border: 'none', backgroundColor: 'white' }}
            onClick={() => setShowSort(!showSort)}
          >
            <div className="sortBy" style={{ cursor: 'pointer' }}>
              <img
                className="sortByIcon"
                src={localhost ? SortByIcon : icons.sortByIcon}
                alt="sortBy"
              />
              <div className="sortLabel">
                {t('sort_by')}
                {' : '}
                <OptionValue initialVal={t('popular')} />
              </div>
            </div>
          </button>
        </span>
        
        <span className="stats">
          {currentRefinement !== '' ? (
            <>
              <CustomStats
                lang={win.document.documentElement.lang}
                query={currentRefinement}
              />
            </>
          ) : null}
        </span>
      </div>
      <div
        className="sortOptions"
        style={{ display: showSort ? 'block' : 'none' }}
        onClick={() => setShowSort(!showSort)}
      >
        <Sort
          defaultRefinement={popular}
          items={[
            { value: popular, label: t('popular') },
            {
              value: asc,
              label: t('price_low_to_high'),
            },
            {
              value: desc,
              label: t('price_high_to_low'),
            },
            {
              value: newer,
              label: t('newer'),
            },
          ]}
        />
      </div>
    </div>
  )
}

export default CustomSortBy
